import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { PLANNING_REDUCER } from '../../../../redux/ReducerNames';
import { FREQUENCY_TYPES, CHANGE_TYPES } from '../../../../redux/planning/Constants';

import withStyles from '@material-ui/core/styles/withStyles';
import { MenuItem, Typography } from '@material-ui/core';
import SimpleSelect from '../common/SimpleSelect';
import SimpleHeading from '../common/SimpleHeading';
import { setFormProperties } from '../../../../redux/search_area/Actions';
import Checkbox from '../../../Common/UI/Checkbox';

import { upperFirst } from 'lodash';

class PlanningAlertSettings extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        frequency: PropTypes.oneOf(FREQUENCY_TYPES).isRequired,
        changeType: PropTypes.oneOf(CHANGE_TYPES).isRequired,
        sendEmail: PropTypes.bool.isRequired,
        sendAppNotification: PropTypes.bool.isRequired,
        // Redux Dispatch
        dispatchSetPlanningAlertFormProperties: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
    }

    handleChange (event) {
        this.props.dispatchSetPlanningAlertFormProperties({ [event.target.name]: event.target.value });
    }

    handleChecked (event) {
        this.props.dispatchSetPlanningAlertFormProperties({ [event.target.name]: event.target.checked });
    }

    render () {
        const { classes, frequency, changeType, sendEmail, sendAppNotification } = this.props;
        return (
            <div className={classes.root}>
                <SimpleHeading label="3. CHOOSE YOUR ALERT SETTINGS" />
                <SimpleHeading
                    variant="subtitle1"
                    label="Frequency"
                    tooltip="Select planning alert frequency (checked at 1:00AM), can be changed later"
                    color="text.primary"
                >
                    <SimpleSelect
                        name="frequency"
                        value={frequency}
                        onChange={this.handleChange}
                    >
                        {FREQUENCY_TYPES.map(e => <MenuItem key={e} value={e}>{upperFirst(e)}</MenuItem>)}
                    </SimpleSelect>
                </SimpleHeading>
                <SimpleHeading
                    variant="subtitle1"
                    label="Change Type"
                    tooltip="Select planning alert change type"
                    color="text.primary"
                >
                    <SimpleSelect
                        name="changeType"
                        value={changeType}
                        onChange={this.handleChange}
                    >
                        {CHANGE_TYPES.map(e => <MenuItem key={e} value={e}>{upperFirst(e)}</MenuItem>)}
                    </SimpleSelect>
                </SimpleHeading>
                <SimpleHeading
                    variant="subtitle1"
                    label="Send App Notification"
                    tooltip="Will send app notifications, can be changed later"
                    color="text.primary"
                >
                    <Checkbox
                        name="sendAppNotification"
                        size="small"
                        checked={sendAppNotification}
                        onChange={this.handleChecked}
                    />
                </SimpleHeading>
                <SimpleHeading
                    variant="subtitle1"
                    label="Send Email"
                    tooltip="Will send emails, can be changed later"
                    color="text.primary"
                >
                    <Checkbox
                        name="sendEmail"
                        size="small"
                        checked={sendEmail}
                        onChange={this.handleChecked}
                    />
                </SimpleHeading>
            </div>
        );
    }
}

const style = theme => ({
    root: {
        '&> *:first-child':{
            marginBottom: theme.constants.verticalMargin
        }
    }
});


const mapStateToProps = state => {
    const form = state[PLANNING_REDUCER].planningAlertForm;
    return {
        frequency: form.frequency,
        changeType: form.changeType,
        sendEmail: form.sendEmail,
        sendAppNotification: form.sendAppNotification
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSetPlanningAlertFormProperties: (props) => dispatch(setFormProperties(PLANNING_REDUCER, props))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PlanningAlertSettings);